import React from 'react'
import injectSheet from 'react-jss'
import Button from 'pobble-components/dist/button'
import posthog from 'posthog-js'

const SCHOOL_TRIAL_FORM_URL =
  'https://share.hsforms.com/2yIHCHPh5TFGK9vy3CBUGoQ4oqv9'

const SCHOOL_TRIAL_FEATURES = [
  'Invite selected teachers to join your trial',
  'Full access for 4 weeks',
  'Every lesson includes differentiated versions'
]

const EXPLORE_FEATURES = [
  'Browse ready-to-use lessons',
  'See what students will experience',
  'No setup needed'
]

export const FSUSchools = injectSheet({
  root: {},
  pitch: {
    font: 'var(--body-)',
    margin: '4px 0 0'
  },
  options: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    margin: '32px 0',
    textAlign: 'left',
    '@media (min-width: 768px)': {
      flexDirection: 'row',
      alignItems: 'stretch'
    }
  },
  option: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
    border: '1px solid var(--light-gray)',
    borderRadius: '8px',
    background: 'var(--off-white, #fafafa)'
  },
  optionTitle: {
    fontSize: '15px',
    margin: 0
  },
  optionDesc: {
    font: 'var(--body-)',
    color: 'var(--gray-)',
    margin: '8px 0 16px',
    lineHeight: '24px',
    fontSize: '15px'
  },
  list: {
    flex: '1',
    padding: '0',
    margin: '0 0 24px',
    listStyle: 'none',
    font: 'var(--body)',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    '& li': {
      display: 'flex',
      gap: '10px',
      alignItems: 'flex-start',
      lineHeight: '24px',
      fontSize: '15px'
    }
  },
  bullet: {
    color: 'var(--green)',
    fontWeight: 'bold',
    flexShrink: 0
  },
  primaryButton: {
    marginTop: 'auto',
    background: 'var(--yellow) !important',
    color: 'var(--gray) !important',
    border: '1px solid var(--gray) !important',
    display: 'flex',
    justifyContent: 'center',
    '&:hover': {
      background: 'var(--yellow-) !important'
    }
  },
  secondaryButton: {
    marginTop: 'auto'
  },
  footerNote: {
    font: 'var(--body-)',
    color: 'var(--gray-)',
    margin: '24px 0 0',
    lineHeight: '24px'
  },
  trustNote: {
    font: 'var(--body-)',
    color: 'var(--gray-)',
    margin: '32px 0 0',
    padding: '16px 0 0',
    borderTop: '1px solid var(--light-gray)',
    lineHeight: '24px'
  }
})(({ classes, onGoToPobble }) => {
  const id = 'fsu-schools'

  return (
    <div className={classes.root}>
      <h2>You’re all set. What would you like to do next?</h2>
      <p className={classes.pitch}>
        If you’re exploring Pobble for your school, here are two simple ways to
        get started.
      </p>
      <div className={classes.options}>
        <div className={classes.option}>
          <h3 className={classes.optionTitle}>Try Pobble across your school</h3>
          <p className={classes.optionDesc}>
            See how it works in more than one classroom.
          </p>
          <ul className={classes.list}>
            {SCHOOL_TRIAL_FEATURES.map(feature => (
              <li key={feature}>
                <span className={classes.bullet} aria-hidden="true">
                  •
                </span>
                <span>{feature}</span>
              </li>
            ))}
          </ul>
          <Button
            minw
            darkBlue
            tall
            href={SCHOOL_TRIAL_FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={`${classes.primaryButton} metrics__fsu_schools_trial`}
            action={() => {
              posthog.capture('user clicked fsu schools cta', {
                id,
                cta: 'trial'
              })
            }}>
            Request a school trial
          </Button>
        </div>
        <div className={classes.option}>
          <h3 className={classes.optionTitle}>Take a look around first</h3>
          <p className={classes.optionDesc}>
            Jump in and explore how Pobble works in practice.
          </p>
          <ul className={classes.list}>
            {EXPLORE_FEATURES.map(feature => (
              <li key={feature}>
                <span className={classes.bullet} aria-hidden="true">
                  •
                </span>
                <span>{feature}</span>
              </li>
            ))}
          </ul>
          <Button
            minw
            tall
            tertiary
            className={`${classes.secondaryButton} metrics__go-to-pobble`}
            action={() => {
              posthog.capture('user clicked fsu schools cta', {
                id,
                cta: 'continue'
              })
              onGoToPobble()
            }}>
            Continue to Pobble
          </Button>
        </div>
      </div>
      <p className={classes.footerNote}>
        You can request a school trial at any time.
      </p>
      <p className={classes.trustNote}>
        <span role="img" aria-label="globe">
          🌎
        </span>{' '}
        Made by teachers, trusted by over a million educators in 70+ countries{' '}
        <span role="img" aria-label="globe">
          🌎
        </span>
      </p>
    </div>
  )
})
